module.exports = __webpack_public_path__ + "be3f12503acc5a5c406b15a702bdb1cc.MP3";